import React from "react";
import { motion } from "framer-motion";

const AboutSection = ({ overview }) => {
  if (!overview) return null;

  return (
    <section className="py-6 lg:py-8 ">
      <div className="max-w-[1700px] mx-auto px-6 sm:px-8 lg:px-10 xl:px-12">
        <motion.div
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="w-full"
        >
          {/* Badge */}
          <div className="inline-flex items-center rounded-full bg-gradient-to-r from-orange-100 via-pink-100 to-purple-100 px-3 py-1.5 text-[11px] sm:text-xs font-semibold uppercase tracking-wide text-orange-600">
            About Our Services
          </div>

          {/* Heading */}
          <h2 className="mt-4 text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight text-gray-900">
            {overview.heading}
          </h2>

          {/* Divider */}
          <div className="mt-3 h-[3px] w-16 rounded-full bg-gradient-to-r from-[#FF7A18] via-[#EC4899] to-[#8B5CF6]" />

          {/* Description */}
          <div className="mt-5">
            <p className="text-[15px] sm:text-base leading-7 text-gray-600 whitespace-pre-line">
              {overview.body}
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;